import tpv from './base';
import { api } from '..';

export default class sibs extends tpv {
    wsBaseUrl = "";
    hotelId = null;

    constructor(isTest, reservation, hotel, tpvPaymentStatus, showConfirmation, showErrorNotification) {
        super();
        this.hotelId = hotel.get('id');
        this.wsBaseUrl = (isTest ? 'https://syn2pre.booking-channel.com' : 'https://synergy.booking-channel.com') + '/api/hotels/' + this.hotelId + "/";

        if (tpvPaymentStatus === 'SIBS:OK' && reservation.get('status') === 'confirmed' && reservation.getIn(['payment', 'payform_code']) === 'htl') {
            showConfirmation(reservation, hotel);
        } else if (tpvPaymentStatus === 'SIBS:ERROR') {
            showErrorNotification('ha ocurrido un error con el proceso de pago online, por favor, vuelva a intentarlo');
        }
    }

    confirm = (reservation, manageLoading, setValidationError) => {
        if (reservation.get('status') === 'confirmed' || reservation.getIn(['payment', 'payform_code']) === 'op') {
            setValidationError(true);
            return;
        }

        setTimeout(() => manageLoading(true), 0);

        /* Con get FUNCIONA pero mejor el post return api.get('sibs_payments') */
        return api.post(
            'hotels/' + this.hotelId + '/sibs_payments/getConfirm',
            [{ hotelCode: reservation.get('hotel_code'), trackingId: reservation.get('tracking_id') }]
        )
            .then((result) => {
                if (result.success) {
                    var url = this.wsBaseUrl + 'cms/redirect_3d_secure/' + reservation.get('hotel_code') + '-' + reservation.get('tracking_id');
                    window.location.replace(url);
                } else {
                    console.error('SibsConfirm error:', result.error);
                    manageLoading(false);
                    setValidationError(true);
                }
            })
            .catch(error => {
                console.error('SibsConfirm error:', error);
                manageLoading(false);
                setValidationError(true);
            });

        /* DA CORS (no siempre)
        return this.getSibsConfirm(reservation.get('hotel_code'), reservation.get('tracking_id'))
            .then(result => {
                if (result.success) {
                    var url = this.wsBaseUrl + 'cms/redirect_3d_secure/' + reservation.get('hotel_code') + '-' + reservation.get('tracking_id');
                    window.location.replace(url);
                } else {
                    manageLoading(false);
                    setValidationError(true);
                    //var url = this.wsBaseUrl + 'cms/redirect_3d_secure_error/' + hotelCode + '-' + trackingId;
                    //window.location.replace(url);
                }
            })
            .catch(error => {
                console.error('SibsConfirm error:', error);
                manageLoading(false);
                setValidationError(true);
            });
        */
    };

    /* Si todo va bien, eliminarla
    getSibsConfirm = (hotelCode, trackingId) => {
        var url = this.wsBaseUrl + 'sibs_payments/getConfirm';
        const data = {
            hotelCode: hotelCode,
            trackingId: trackingId,
        };

        return this.query(url, 'POST', data);
    };*/
}
